import { IssueReportTypeItem } from './IssueReportTypeItem'

export const DailyInspectionInspection = new IssueReportTypeItem({
  id: '087a8c90-0e6b-49a2-8a22-ae1e2c76fb76',
  classType: 'DailyInspectionInspection',
  label: 'inspectionId',
  type: 'Inspection',
})

export const DailyInspectionControlPoint = new IssueReportTypeItem({
  id: '362e7ae2-2228-46ab-8d4a-a0d56089d10e',
  classType: 'DailyInspectionControlPoint',
  label: 'controlPointId',
  type: 'Control Point',
})

export const DailyInspectionPunchList = new IssueReportTypeItem({
  id: '90d8fef3-9a75-4751-948f-c83267d51c81',
  classType: 'DailyInspectionPunchList',
  label: 'punchListId',
  type: 'Punch List',
})

export const ConcreteTest = new IssueReportTypeItem({
  id: '42b05837-080f-46cf-8853-6399460c6f0e',
  classType: 'ConcreteTest',
  label: 'fieldNumber',
  type: 'Concrete Test',
})

export const ConcreteTestSet = new IssueReportTypeItem({
  id: '01bd64e9-026a-49c1-9dbb-906dd00ac330',
  classType: 'ConcreteTestSet',
  label: 'testSetId',
  type: 'Concrete Test Set',
})

export const DensityLot = new IssueReportTypeItem({
  id: '2c6755ac-a2bb-46af-beb1-417178935eef',
  classType: 'Lot',
  label: 'lotId',
  type: 'Density Lot',
})

export const AsphaltLot = new IssueReportTypeItem({
  id: 'b88b60f5-519f-4a44-a3ba-6561e661b76f',
  classType: 'AsphaltLot',
  label: 'asphaltLotId',
  type: 'Asphalt Lot',
})
